export default "__VITE_ASSET__CBg2CN_a__"